import { onDocumentReady } from "@story/story_assets";
import L from "leaflet";

const API_KEY = "uFk1iq6Se7pcuZME5yvcnOWizeDOJZS9xWfmxAz4H5E";

onDocumentReady(() => {
	const position = [50.0870900, 15.9747764];

	const mapElement = document.querySelector("#map");
	if (!mapElement) {
		return;
	}

	const map = L.map(mapElement).setView(position, 13);
	map.attributionControl.setPrefix(false);

	L.tileLayer(`https://api.mapy.cz/v1/maptiles/basic/256@2x/{z}/{x}/{y}?apikey=${API_KEY}`, {
		minZoom: 0,
		maxZoom: 19,
		attribution: "<a href='https://api.mapy.cz/copyright' target='_blank'>&copy; Seznam.cz a.s. a další</a>",
	}).addTo(map);

	L.marker(position, {
		icon: L.icon({
			iconUrl: RAILS_ASSET_URL("marker-icon.png"),
			iconSize: [25, 41],
			iconAnchor: [25 / 2, 41],
		})
	}).addTo(map);

});
